/**
 * Created by Languagenut on 17/06/2019.
 */


import React  from 'react';
import {Bar} from 'react-chartjs-2';
import translation from '../../store/internationalization-store.js';
/*{id:'listening' , name:'Écouter'},
{id:'speaking' , name:'Parler'},
{id:'reading' , name:'Lire'},
{id:'writing' , name:'Écrire'},*/

const data = {
    labels: [translation.get(119 , 'Reading'), translation.get(117 , 'Listening'), translation.get(117 , 'Listening'), translation.get(608 ,'April'), translation.get(609 ,'May'), translation.get(610 ,'June'), translation.get(611,'July' ),translation.get(612,'August'),translation.get(613,'September'),translation.get(614,'October'),translation.get(615,'November') , translation.get(616,'December')],
    datasets: [
        {
            label: 'Words Learnt',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgba(179,181,198,1)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [10, 40, 50, 10, 100, 55, 40]
        },
    ]
};


export default class LearntLine extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentWillReceiveProps(props){
        this.props  = props;
        this.setState({update:true});
    }

    get($key){

        var response = [];
        var data = this.props[$key] || [];

        for(var idx = 1; idx <= 12; idx++)
        {
            let number = 0;

            for(var jdx = 0 ; jdx < data.length; jdx++)
            {
                if(data[jdx].month == idx)
                {
                    number = data[jdx].total;
                    continue;
                }
            }

            response.push(number)
        }

        return response;
    }

    render(){

    //vocabulary
    //pronance
    //grammer

        var d = this.props.data || [];
        var p = [];
        for(var i = 0; i < d.length; i ++)
        {
            p.push(Math.floor(d[i]))
        }

        let data = {
            labels: this.props.labels,
            datasets: [
                {
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: '#1f1535',
                    borderColor: 'rgba(179,181,198,1)',
                    pointBackgroundColor: 'rgba(179,181,198,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(179,181,198,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: p
                },
            ]
        };

        const options = {
            legend:{
                display:false,
                position:'bottom',
                boxWidth:5,
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                        display:false
                    }
                }],
                yAxes: [

                    {
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                            display:false
                        },
                        ticks: {
                            min:0,
                            max:100,
                        },
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                    },
                ]
            }
        };

            return  <div>
                <Bar  height={300} data={data}  options={options} />
            </div>
    }
}